var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#313fc4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    className: "c",
    d: "m5.47,6.73v2.53h51.8v40.43H24.42v2.53h34.11c.69-.01,1.25.54,1.26,1.22,0,.01,0,.03,0,.04v1.26H24.42v2.53h36.64c.7,0,1.26-.57,1.26-1.26v-2.53c-.07-1.51-1.08-2.81-2.53-3.26V8c0-.7-.57-1.26-1.26-1.26H5.47Zm6.32,7.58c-4.88,0-8.84,3.96-8.84,8.84s3.96,8.84,8.84,8.84,8.84-3.96,8.84-8.84c-.01-4.88-3.96-8.83-8.84-8.84Zm13.9,0v2.53h15.16v-2.53h-15.16Zm18.95,0v2.53h8.84v-2.53h-8.84Zm-32.85,2.53c3.49,0,6.32,2.83,6.32,6.32s-2.83,6.32-6.32,6.32-6.32-2.83-6.32-6.32c-.01-3.48,2.8-6.31,6.28-6.32.01,0,.03,0,.04,0Zm13.9,3.79v2.53h27.79v-2.53h-27.79Zm10.56,7.25c-.28,0-.56.02-.84.07-1.14.2-2.16.85-2.82,1.8l-4.88,7.06-4.58-1.53c-1.52-.5-3.1-.76-4.7-.76h-9.16c-4.18.01-7.57,3.4-7.58,7.58v15.16h2.53v-15.16c0-2.78,2.24-5.04,5.02-5.05.01,0,.02,0,.04,0h9.16c1.33,0,2.64.21,3.9.63l5.49,1.83c.53.18,1.12-.02,1.44-.48l5.42-7.85c.55-.82,1.67-1.04,2.49-.49.02.01.04.02.05.04h0c.81.57,1.01,1.69.45,2.5,0,0,0,0,0,0l-7.17,10.44c-.31.45-.87.65-1.39.5l-8.12-2.34c-.67-.19-1.37.19-1.56.87-.03.11-.05.23-.05.35v14.22h2.53v-12.54l6.5,1.88c1.57.45,3.24-.15,4.17-1.5h0l7.16-10.43h0c1.33-1.95.86-4.61-1.06-5.99-.71-.5-1.55-.78-2.42-.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStaff);
export default __webpack_public_path__ + "static/media/totalStaff.191e7c9a2996571ad14240c965b4b86b.svg";
export { ForwardRef as ReactComponent };